import { useState } from "react";
import Form from "../Form/Form";
import css from "./AddEquipment.module.css";
import SalesEquipmentOptions from "./SalesEquipmentOptions";
import FormType from "../Form/FormType";

const AddSalesEquipment = ({ onSubmit }) => {
	const [options, setOptions] = useState(SalesEquipmentOptions);

	// 🔹 Handle Task Type (service) change
	const handleTaskTypeChange = (selected) => {
		const selectedServiceId = selected?.id || selected?.value;
		let updatedFields = [...options.Fields];

		// Check if surveyType already exists
		const hasSurveyField = updatedFields.some((fld) => fld.name === "surveyType");

		if (selectedServiceId === 4 && !hasSurveyField) {
			// Add Survey Type radio field when Task Type ID = 4
			updatedFields.push({
				element: FormType.RadioGroup,
				required: true,
				name: "surveyType",
				label: "Survey Type",
				changeEvent: true, // ✅ allow FormRow to pass onChange
				value: "",
				options: [
					{ label: "Field Survey", value: "field" },
					{ label: "Self Survey", value: "self" },
				],
			});
		} else if (selectedServiceId !== 4 && hasSurveyField) {
			// Remove Survey Type radio field when Task Type ≠ 4
			updatedFields = updatedFields.filter((f) => f.name !== "surveyType");
		}

		// Update Task Type field value
		updatedFields = updatedFields.map((fld) =>
			fld.name === "service" ? { ...fld, value: selected } : fld
		);

		setOptions((prev) => ({ ...prev, Fields: updatedFields }));
	};

	// 🔹 Handle change for inputs like RadioGroup
	const handleChange = (e) => {
		const { name, value } = e.target;
		const updatedFields = options.Fields.map((fld) =>
			fld.name === name ? { ...fld, value } : fld
		);
		setOptions((prev) => ({ ...prev, Fields: updatedFields }));
	};

	// Attach the onSelected handler dynamically to service field
	const serviceField = options.Fields.find((fld) => fld.name === "service");
	if (serviceField) {
		serviceField.onSelected = handleTaskTypeChange;
	}

	const init = () => {
		const reset = { ...options };
		reset.Fields.forEach((f) => (f.value = ""));
		setOptions(reset);
	};

	const handleSubmit = () => {
		onSubmit && onSubmit(options);
		init();
	};

	return (
		<div className={css.AddEquipment}>
			{options && <Form onSubmit={handleSubmit} onChange={handleChange}>{options}</Form>}
		</div>
	);
};

export default AddSalesEquipment;
